import { render } from "./AlteriPanelEntry.vue?vue&type=template&id=4ac8b8f5&scoped=true&ts=true"
import script from "./AlteriPanelEntry.vue?vue&type=script&lang=ts"
export * from "./AlteriPanelEntry.vue?vue&type=script&lang=ts"

import "./AlteriPanelEntry.vue?vue&type=style&index=0&id=4ac8b8f5&scoped=true&lang=scss"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac8b8f5"]])

export default __exports__